var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"label":"attestati","label-size":"sm","label-cols-sm":1,"description":`Set value or FDO reference.`}},[_c('b-form-input',{attrs:{"size":"sm"},model:{value:(_vm.value[1]),callback:function ($$v) {_vm.$set(_vm.value, 1, $$v)},expression:"value[1]"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }